<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import JobRoleBase from '../../../../../job_roles/components/JobRoleBase.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

// The settings layout hands every tab the site; this one reads it from the site context instead
defineOptions({ inheritAttrs: false })
</script>

<template>
  <JobRoleBase />
</template>
